<template>
  <div class="sidebar-item" v-if="!item.hidden">
    <template
      v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path, onlyOneChild.query)">
        <!-- 二级菜单 -->
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }">
          <svg-icon v-if="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :icon-class="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" />
          <template #title><span class="menu-title" :title="hasTitle(onlyOneChild.meta.title)">{{
            onlyOneChild.meta.title }}</span></template>
        </el-menu-item>
      </app-link>
    </template>
    <!-- 一级菜单 -->
    <el-sub-menu v-else ref="subMenu" :index="resolvePath(item.path)" teleported>
      <template v-if="item.meta" #title>
        <svg-icon :icon-class="getIconClass(item.meta.icon, item.path)" />
        <!-- <svg-icon :icon-class="item.meta && item.meta.icon" /> -->
        <span class="menu-title" :title="hasTitle(item.meta.title)">{{ item.meta.title }}</span>
      </template>

      <sidebar-item v-for="(child, index) in item.children" :key="child.path + index" :is-nest="true" :item="child"
        :base-path="resolvePath(child.path)" class="nest-menu" />
    </el-sub-menu>
  </div>
</template>

<script setup>
import { isExternal } from '@/utils/validate'
import AppLink from './Link'
import { getNormalPath } from '@/utils/ruoyi'
import { useRoute } from 'vue-router'
const route = useRoute()

const props = defineProps({
  // route object
  item: {
    type: Object,
    required: true
  },
  isNest: {
    type: Boolean,
    default: false
  },
  basePath: {
    type: String,
    default: ''
  }
})

const onlyOneChild = ref({});

// 响应式数据存储当前激活的路径
const activePath = computed(() => route.path)
// 获取图标类名，支持动态传入默认图标名称
function getIconClass(defaultIcon, path) {
  const currentPath = activePath.value
  const targetPath = path

  // 判断当前路径是否匹配此菜单项
  const isActive = currentPath === targetPath ||
    currentPath.startsWith(targetPath + '/') ||
    currentPath.split('?')[0] === targetPath ||
    currentPath.split('?')[0].startsWith(targetPath + '/')

  // 如果有默认图标，则使用默认图标，否则使用 fallback 图标
  const normalIcon = defaultIcon || 'default_常态'
  const activeIcon = (defaultIcon?.replace('_常态', '_选中') || 'default_选中')
  return isActive ? activeIcon : normalIcon
}


function hasOneShowingChild(children = [], parent) {
  if (!children) {
    children = [];
  }
  const showingChildren = children.filter(item => {
    if (item.hidden) {
      return false
    }
    onlyOneChild.value = item
    return true
  })

  // When there is only one child router, the child router is displayed by default
  if (showingChildren.length === 1) {
    return true
  }

  // Show parent if there are no child router to display
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: '', noShowingChildren: true }
    return true
  }

  return false
};

function resolvePath(routePath, routeQuery) {
  if (isExternal(routePath)) {
    return routePath
  }
  if (isExternal(props.basePath)) {
    return props.basePath
  }
  if (routeQuery) {
    let query = JSON.parse(routeQuery);
    return { path: getNormalPath(props.basePath + '/' + routePath), query: query }
  }
  return getNormalPath(props.basePath + '/' + routePath)
}

function hasTitle(title) {
  if (title.length > 5) {
    return title;
  } else {
    return "";
  }
}
</script>
